import { render, staticRenderFns } from "./zhongkeYC.vue?vue&type=template&id=d01f7146&scoped=true"
import script from "./zhongkeYC.vue?vue&type=script&lang=js"
export * from "./zhongkeYC.vue?vue&type=script&lang=js"
import style0 from "./zhongkeYC.vue?vue&type=style&index=0&id=d01f7146&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01f7146",
  null
  
)

export default component.exports